import React from 'react';
import styled from '@tanium/react-emotion';
import { StateCriticalIcon } from '@tanium/react-graphics';
import { Stack, StackChild } from '@tanium/react-stack';
import { css } from '@tanium/style-system';
import { ErrorText } from './themeDefinitions';

export interface Props {
  children: React.ReactNode;
}

const ErrorContainer = styled('div')(
  css({
    color: ErrorText,
    lineHeight: '16px',
  }),
);

const iconStyle = { display: 'block' };

export const FormInlineError = ({ children }: Props) => (
  <Stack role="alert" component={ErrorContainer} itemSpacing={1 / 2} alignItems="flex-start">
    <StateCriticalIcon height={16} width={16} style={iconStyle} />
    <StackChild>{children}</StackChild>
  </Stack>
);
